import { Badge } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { MeetingStatus, meetingStatusTextMap } from 'entities/Meeting';

import Text from '../Text';

type Props = {
  status: MeetingStatus;
};

const MeetingBadge: React.FC<Props> = ({ status }) => {
  const currentStatus = meetingStatusTextMap[status];

  return (
    <Badge color={currentStatus.color} variant="light" size="lg" h={22}>
      <Text size="xs" fw="600">
        {currentStatus.label}
      </Text>
    </Badge>
  );
};

export default observer(MeetingBadge);
